import { getContext, setContext } from "svelte";

export type SubmitValidator = () => boolean;

const submitValidatorsContextKey = "submitValidators";

export function createSubmitValidators(): Set<SubmitValidator> {
	return setContext(submitValidatorsContextKey, new Set<SubmitValidator>());
}

export function getSubmitValidators(): Set<SubmitValidator> | undefined {
	return getContext<Set<SubmitValidator> | undefined>(submitValidatorsContextKey);
}
